import React, { Component } from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";
// import Header from './Header.js';
import PurchaseOrderViewModal from '../../../common/components/PurchaseOrderView';
import { getColumns, DEFAULTSORTED, DEFAULTPAGESIZE } from './table.conf.js';
import { updateInPath, nullsToStrings } from '../../../../common/utils';
import { Dimmer } from 'semantic-ui-react';


class PurchaseOrders extends Component {
  constructor(props) {
    super();

    this.state = {
      modal: {
        open: false,
        data: {}
      },
      dimmer: false
    };
  }

  handlePurchaseOrderViewClose = (refreshData) => {
    this.setState(s => updateInPath(s, 'modal.open', false));
    if (refreshData) {
     // this.props.refresh();
    }
  }

  handlePurchaseOrderViewOpen = async (e, { purchaseOrderId, userId }) => {
    this.setState(s => updateInPath(s, 'dimmer', true));
    const po = await this.props.onViewPurchaseOrder(purchaseOrderId, userId);
    this.setState(s => updateInPath(s, 'modal.data', e ? null : nullsToStrings(po)));
    this.setState(s => updateInPath(s, 'modal.open', true));
    this.setState(s => updateInPath(s, 'dimmer', false));
  }

  handleSelectEvent = (e, { value }) => {
    this.props.refresh(value);
  }
  
  render() {
    const { data, loading, exportStatus } = this.props,
          { modal, dimmer } = this.state;

    return (
      <div>
        <Dimmer inverted active={dimmer} />
        { modal.open && <PurchaseOrderViewModal
                          open={modal.open}
                          data={modal.data}
                          isAdmin={true}
                          exportStatus={exportStatus}
                          onExport={this.props.onExport}
                          onClose={this.handlePurchaseOrderViewClose}
                        />}
        {/* <Header */}
        {/*   onSelectEvent={this.handleSelectEvent} */}
        {/* /> */}
        <ReactTable
          className='-striped -highlight'
          data={data}
          loading={loading}
          getTrProps={(state, rowInfo) => ({
            onClick: e => this.handlePurchaseOrderViewOpen(null, rowInfo.original)
          })}
          columns={getColumns()}
          defaultSorted={DEFAULTSORTED}
          defaultPageSize={DEFAULTPAGESIZE}
          noDataText='No purchase orders'
        />
      </div>
    );
  };
};

export default PurchaseOrders;



// WEBPACK FOOTER //
// ./src/private/admin/components/PurchaseOrders/index.js